import React, { useEffect, createRef, useState } from "react"
//Components
import Layout from "../components/layout"
// bootstrap ----------------------
import { Col, Container, Row, Button } from 'react-bootstrap';
// css ---------------------------
import { css } from '@emotion/react';
import styled from '@emotion/styled';
// images -------------------------
import ellipse from './../../static/ellipse.svg'
import imgBannerRadial from './../../static/backgroundBanner.png'
// animation
import lottie from "lottie-web";
// video
import Video from './../components//video/Video';
// 
import GlobeLottie from "../resources/animations/3169-world.json";

const AboutUs = () => {

    const [showVideo, setShowVideo] = useState(false)


    const [tabs1, setTabs1] = useState(true)
    const [tabs2, setTabs2] = useState(false)
    const [tabs3, setTabs3] = useState(false)

    const GlobeAnimation = createRef()

    useEffect(() => {
        const anim = lottie.loadAnimation({
            container: GlobeAnimation.current,
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData: GlobeLottie
        });
        return () => anim.destroy(); // optional clean up for unmounting
    }, []);

    const Radial = styled.section`
		min-height:100vh;
		background-image: url(${imgBannerRadial}); /* The image used */
		background-position: center; /* Center the image */
		background-repeat: no-repeat; /* Do not repeat the image */
		background-size: cover; /* Resize the background image to cover the entire container */
		position:relative;
	`;
    const TitleAboutUs = styled.h2`
		font-size:3rem;
		color:#293594;
		font-weight:bold;
		@media (max-width: 768px){
			text-align:center !important;
		}
	`;
    const Elipse = styled.section`
		min-height:100vh;
		background-image: url(${ellipse}); /* The image used */
		background-position: bottom; /* Center the image */
		background-repeat: no-repeat; /* Do not repeat the image */
		background-size: contain; /* Resize the background image to cover the entire container */
		position:relative;
		position: absolute;
		/* top:20%; */
		left:0;
		right:0;
		top:-10%;
	`;
    const BodyTextIntro = styled.p`
        width:75%;
        font-size:1.5rem;
        @media (max-width:992px){
            width:100%;
            text-align:center;
        }
	`;
    const CircleOne = styled.div`
        width: 8%;
        position: absolute;
        top: 50%;
        left: 10%;
        div{
            position:relative;
            img.circle{
                max-width: 140px;
                max-height: 140px;
                width:80%;
            }
            img.person{
                max-width: 400px;
                max-height: 400px;
                width: 100%;
                left: -47%;
                bottom: 0;
                position: absolute;
                bottom: 0;
                top: 30%;
            }
        }
        @media (max-width:1630px){
            top: 61%;
        }
        @media (max-width:992px){
            width: 15%;
        }
        @media (max-width:992px){
            width: 20%;
        }
    `;
    const CircleTwo = styled.div`
         width: 11%;
        position: absolute;
        top: 78%;
        left: 28%;
        div{
            position:relative;
            img.circle{
                max-width: 300px;
                max-height: 300px;
                width:60%;
            }
            img.person{
                max-width: 300px;
                max-height: 300px;
                width: 98%;
                left: 23%;
                bottom: 0;
                position: absolute;
                bottom: 0;
                top: 30%;
            }
        }
        @media (max-width:992px){
            width: 13%;
        }
        @media (max-width:992px){
            width: 17%;
        }
    `;
    const CircleThree = styled.div`
         width: 10%;
        position: absolute;
        top: 87%;
        left: 60%;
        div{
            position:relative;
            img.circle{
                max-width: 300px;
                max-height: 300px;
                width: 60%;
            }
            img.person{
                max-width: 300px;
                max-height: 300px;
                width: 98%;
                left: 7%;
                bottom: 0;
                position: absolute;
                bottom: 0;
                top: -88%;
            }
        }
        @media (max-width:992px){
            width: 16%;
        }
        @media (max-width:992px){
            width: 20%;
        }
    `;
    const CircleFour = styled.div`
        width: 9%;
        position: absolute;
        top: 66%;
        left: 86%;
        div{
            position:relative;
            img.circle{
                max-width: 300px;
                max-height: 300px;
                width: 60%;
            }
            img.person{
                max-width: 300px;
                max-height: 300px;
                width: 90%;
                left: 26%;
                bottom: 0;
                position: absolute;
                bottom: 0;
                top: -72%;
            }
        }
        @media (max-width:992px){
            width: 14%;
            left: 80%;
        }
        @media (max-width:992px){
            width: 20%;
            left: 75%;
        }
    `;
    const Globe = styled.section`
        
    `;
    const TitleGlobe = styled.h2`
        font-size:3rem;
		color:#293594;
		font-weight:bold;
		@media (max-width: 768px){
			text-align:center !important;
		}
    `;
    const HowMake = styled.section`
        background: #E1F095;
        border-radius: 0px 0px 120px 120px;
        @media (max-width:768px){
            border-radius: 0px 0px 50px 50px;
        }
    `;
    const Crew = styled.section`
        background: #E1F095;
        border-radius: 0px 0px 120px 120px;
        transform: rotate(-180deg);

        .container{
            transform: rotate(180deg);
            padding-top:10rem; padding-bottom:10rem;
        }
        @media (max-width:768px){
            border-radius: 0px 0px 50px 50px;
        }
        @media (max-width:992px){
            .container{
            padding-top:3rem; padding-bottom:3rem;
        }
        }
    `;
    const NameCrew = styled.p`
        font-family: Gloria Hallelujah;
        font-size: 2rem;
        color: #293594;
        @media (max-width:992px){
            font-size:1.2rem;
        }
    `;
    const Valores = styled.section`
        padding:8rem 0rem;
        @media (max-width:992px){
            padding:3rem 0rem;
        }
    `;
    const CardValores = styled.div`
        background: #F9F9F9;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
        padding:3rem 1rem;
        min-height: 350px;
        margin-bottom:2rem;
        img{
            padding:2rem 0rem;
        }
        p.title{
            font-family: Roboto;
            font-weight: 500;
            font-size: 1.5rem;
            line-height: 35px;
            color: #000000;
            text-align:center;
        }
        p.body{
            font-family: Open Sans;
            font-size: 1.2rem;
            line-height: 35px;
            text-align:center;
            color: #000000;
        }
    `;
    const Discover = styled.section`
        background: linear-gradient(180deg, rgba(169, 231, 234, 0.58) 8.54%, rgba(196, 196, 196, 0) 100%);
        padding:8rem 0rem;
        @media (max-width:992px){
            padding:3rem 0rem;
        }

        @media (max-width:1200px){
            .DiscoverInfo{
                width:100% !important;
            }
        }
    `;
    const LineDiscoverTitle = styled.div`
        max-width: 767px;
        padding:20px;
        margin:auto;
        hr{
            color: black;
            height: 0.5px;
            background: black;
        }   
        /* background:black; */
    `;
    const SubTitleDiscover = styled.p`
        font-family: Open Sans;
        font-size: 26px;
        color: #000000;
        width:70%;
        text-align:center;
        margin:auto;

    `;
    const Functions = styled.section`
        background: linear-gradient(180deg, rgba(223, 243, 128, 0.8) 8.54%, rgba(196, 196, 196, 0) 100%);
    `;
    const CardIdea = styled.div`
        background: rgba(225, 240, 149, 0.8);
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
        padding:2rem;
    `;
    const CardIdeaBlue = styled.div`
        background: rgba(0, 80, 233,1);
        position: absolute;
        padding: .5rem 1.5rem;
        right: -10%;
        top: 75%;
        @media( max-width:590px){
            right: 7%;
        }
    `;
    const ImageCrew = styled.img`
    /* background: #FFFFFF; */
    box-shadow: 0px 20px 10px rgba(0, 0, 0, 0.15);
    border-radius:5px;
    margin-bottom:2rem;
`;

    const ContainerItemIdea = styled.div`
        cursor: ${props => props.active ? "normal" : "pointer"};
        opacity: ${props => props.active ? "1" : "0.5"};
    `;

    const ContainerGenetaTabs = styled(Container)`
        display: flex !important;
        flex-direction:column !important;
        justify-content:center !important;

        @media(max-width:992px){
            flex-direction:column-reverse !important;
        }
    `;


    const tabIdea = (value) => {
        if (value == 1) {
            setTabs1(true)
            setTabs2(false)
            setTabs3(false)
        } else if (value === 2) {
            setTabs1(false)
            setTabs2(true)
            setTabs3(false)
        } else {
            setTabs1(false)
            setTabs2(false)
            setTabs3(true)
        }
    }

    return (
        <Layout>
            <Radial className="d-flex align-items-center position-relative">
                <Container>
                    <Row>
                        <Col lg={8} className="mb-5" css={css`
                        padding-left:15%;
                        @media (max-width:992px){
                            padding-left:15px;
                        }
                        `}>
                            <TitleAboutUs className="text-center text-lg-left">Somos Social Energy</TitleAboutUs>
                            <BodyTextIntro>
                                Un equipo de jóvenes innovadores que buscamos entregar energía limpia de manera más eficiente y amigable con el medio ambiente a través de nuevas tecnologías.
							</BodyTextIntro>
                        </Col>
                    </Row>
                </Container>
                <Elipse></Elipse>
                <CircleOne>
                    <div>
                        <img alt="circle" className="circle" src={'/blueCircle.svg'} />
                        <img alt="person_1" className="person" src={'/person_1.png'} />
                    </div>
                </CircleOne>
                <CircleTwo>
                    <div>
                        <img alt="circle" className="circle" src={'/greenCircle.svg'} />
                        <img alt="person_2" className="person" src={'/person_2.png'} />
                    </div>
                </CircleTwo>
                <CircleThree>
                    <div>
                        <img alt="circle" className="circle" src={'/oliveCircle.svg'} />
                        <img alt="person_3" className="person" src={'/person_3.png'} />
                    </div>
                </CircleThree>
                <CircleFour>
                    <div>
                        <img alt="circle" className="circle" src={'/lemonCircle.svg'} />
                        <img alt="person_4" className="person" src={'/person_4.png'} />
                    </div>
                </CircleFour>
            </Radial>
            <Globe>
                <Container>
                    <Row className="d-flex align-items-center">
                        <Col xl={6} lg={12} sm={12} className="mt-0 mt-xl-5 pt-0 pt-xl-5">
                            <div>
                                <TitleGlobe>¿Por qué lo hacemos? </TitleGlobe>
                                <p className="mt-3 text-center text-md-left" css={css`font-size:1.5rem;`}>
                                    Creemos que el uso de combustibles fósiles, como el gas,
                                    para la creación de agua caliente sanitaria y calefacción es
                                    hoy en día anticuado e ineficiente y su reducción y hasta eliminación
                                    es un paso esencial para que nuestro planeta tenga un respiro,
                                    y sumado al ahorro que implica para los clientes y a las nuevas
                                    leyes de eficiencia energética de nuestro país comienza a perder
                                    su atractivo económico.
                                    </p>
                            </div>
                        </Col>
                        <Col xl={6} lg={12} sm={12} className="my-0 my-xl-5 py-0 py-xl-5">
                            <div>
                                <div className="animation-container" ref={GlobeAnimation} />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Globe>
            <HowMake>
                <Container fluid>
                    <Row css={css`
                    padding-top:7rem;
                     padding-bottom:9rem;
                     @media (max-width:992px){
                        padding-top:2rem;
                     padding-bottom:3rem;
                     }
                     `} className="d-flex align-items-center">
                        <Col lg={6} md={12} className="pl-3 pl-lg-0  mb-5 mb-lg-0">
                            {
                                showVideo ?
                                    <Video
                                        // videoSrcURL="https://www.youtube.com/embed/dQw4w9WgXcQ"
                                        videoSrcURL="https://www.youtube.com/embed/RnuU8h96Igs"
                                        videoTitle="Social Energy"
                                    />
                                    :
                                    <div onClick={() => setShowVideo(true)} css={css`cursor:pointer;`}>
                                        <img alt="video" className="img-fluid w-100" src={'/video.jpg'} />
                                    </div>
                            }

                        </Col>
                        <Col lg={6} md={12}>
                            <div className="w-75 m-auto">
                                <TitleGlobe>¿Cómo lo hacemos?</TitleGlobe>
                                <p className="mt-3 text-justify text-md-left" css={css`font-size:1.5rem;`}>
                                    Buscamos diversas tecnologías a nivel global que nos ayuden a lograr nuestros proyectos, una de estas tecnologías es la bomba de calor, la cual queremos reemplazar por las costosas y anticuadas calderas de gas de las comunidades del país.
                                    </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </HowMake>
            <section css={css`
                    padding-top:10rem;
                     padding-bottom:10rem;
                     @media (max-width:992px){
                        padding-top:4rem;
                     padding-bottom:4rem;
                     }
                     `}>
                <div className="w-75 m-auto">
                    <TitleGlobe className="text-center">¿Qué hacemos?</TitleGlobe>
                    <p className="mt-3 text-center" css={css`font-size:1.5rem;`}>
                        Ofrecemos soluciones de eficiencia energética a comunidades, inmobiliarias y constructoras, de tal manera que entre todos, generemos un país libre de emisiones de gas para creación de agua caliente sanitaria y calefacción en un futuro cercano.
                    </p>
                </div>
            </section>
            <Crew>
                <Container>
                    <TitleGlobe className="text-right">Nuestro equipo de liderazgo</TitleGlobe>
                    <Row className="justify-content-between mt-5">
                        <Col lg={3} md={4} className="text-center mb-5">
                            <ImageCrew alt="leader_a" className="img-fluid w-100" src={'/Fernando soto.png'} />
                            <NameCrew className="text-center">Fernando Soto</NameCrew>
                            <a href="https://www.linkedin.com/in/social-energy-chile-spa-412243191" target="_blank" rel="noopener noreferrer">
                                <img alt="linkedinIcon" className="img-fluid m-auto" css={css`max-width:100px;`} src={'/linkedinIcon.svg'} />
                            </a>
                        </Col>
                        <Col lg={3} md={4} className="text-center mb-5">
                            <ImageCrew alt="leader_b" className="img-fluid w-100" src={'/Tahia Villegas.png'} />
                            <NameCrew className="text-center">Tahia Villegas</NameCrew>
                            <a href="https://www.linkedin.com/in/tahia-villegas-soza-82219062" target="_blank" rel="noopener noreferrer">
                                <img alt="linkedinIcon" className="img-fluid m-auto" css={css`max-width:100px;`} src={'/linkedinIcon.svg'} />
                            </a>
                        </Col>
                        <Col lg={3} md={4} className="text-center mb-5">
                            <ImageCrew alt="leader_c" className="img-fluid w-100" src={'/Sebastian Parada.png'} />
                            <NameCrew className="text-center">Sebastian Parada</NameCrew>
                            <a href="https://www.linkedin.com/in/sebastian-parada-muñoz-181a1318a" target="_blank" rel="noopener noreferrer">
                                <img alt="linkedinIcon" className="img-fluid m-auto" css={css`max-width:100px;`} src={'/linkedinIcon.svg'} />
                            </a>
                        </Col>
                    </Row>
                </Container>
            </Crew>
            <Valores>
                <Container>
                    <TitleGlobe className="text-center">Nuestros valores</TitleGlobe>
                    <Row className="mt-5">
                        <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                            <CardValores className="text-center">
                                <img alt="linkedinIcon" className="img-fluid m-auto" css={css`max-width:100px;`} src={'/handIcon.svg'} />
                                <p className="title">Enfocados al cliente</p>
                                {/* <p className="body">Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p> */}
                            </CardValores>
                        </Col>
                        <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                            <CardValores className="text-center">
                                <img alt="linkedinIcon" className="img-fluid m-auto" css={css`max-width:100px;`} src={'/iconCrew.svg'} />
                                <p className="title">Trabajo en equipo</p>
                                {/* <p className="body">Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p> */}
                            </CardValores>
                        </Col>
                        <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                            <CardValores className="text-center">
                                <img alt="linkedinIcon" className="img-fluid m-auto" css={css`max-width:100px;`} src={'/bottleIcon.svg'} />
                                <p className="title">Transparencia</p>
                                {/* <p className="body">Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p> */}
                            </CardValores>
                        </Col>
                        <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                            <CardValores className="text-center">
                                <img alt="linkedinIcon" className="img-fluid m-auto" css={css`max-width:100px;`} src={'/iconEnergy.svg'} />
                                <p className="title">Excelencia en servicio entregado</p>
                                {/* <p className="body">Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p> */}
                            </CardValores>
                        </Col>
                    </Row>
                </Container>
            </Valores>
            <section className="mb-0 pb-0 mb-lg-4 pb-lg-5">
                <ContainerGenetaTabs>
                    <Row className="d-flex align-items-center uno">
                        <Col lg={6} sm={12}>
                            {
                                tabs1 ?
                                    <div className="">
                                        <TitleGlobe>Como empezó todo</TitleGlobe>
                                        <p className="mt-3" css={css`font-size:1.5rem;`}>
                                            Social Energy, es una comercializadora de energía eléctrica,
                                            con la motivación de crear procesos eficientes y optimizados
                                            para nuestros clientes. En conjunto con las tecnologías innovadoras
                                            que ofrece <span><a href="http://www.ecogreenchile.cl/" target="_blank" css={css`color:#293594;`}>Ecogreen</a></span> surge la idea de entregar
                                            soluciones cada vez más sustentables al área de energía, la cual
                                            representa un alto porcentaje de emisiones contaminantes.
                                            Esto no se detiene aquí, cada día se crean nuevas tecnologías
                                            y como equipo estudiamos cada día nuevas oportunidades desarrollándose
                                            en el extranjero para lograr una mejora continua de nuestros
                                            procesos y cada vez mayor aprovechamiento de los recursos.
                                        </p>
                                    </div>
                                    :
                                    tabs2 ?
                                        <div className="">
                                            <TitleGlobe>Se crea el primer prototipo</TitleGlobe>
                                            <p className="mt-3" css={css`font-size:1.5rem;`}>
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
                                                ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                                ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore
                                                eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                                            </p>
                                        </div>
                                        :
                                        <div className="">
                                            <TitleGlobe>Llegan los primeros inversionistas</TitleGlobe>
                                            <p className="mt-3" css={css`font-size:1.5rem;`}>
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
                                                ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                                ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore
                                                eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                                            </p>
                                        </div>
                            }
                        </Col>
                        <Col lg={6} sm={12}>
                            <div className="my-5 py-5 text-center  d-none d-lg-block"><img alt="Clock" className="img-fluid" src={'/wireframe.png'} /></div>
                        </Col>
                    </Row>
                    <Row className="justify-content-around mt-5 dos">
                        <Col lg={3} md={6} sm={12} className="position-relative mb-5">
                            <ContainerItemIdea active={tabs1} onClick={() => tabIdea(1)}>
                                <CardIdea>
                                    <p className="text-center mb-0">Todo comenzo con una idea</p>
                                </CardIdea>
                                <CardIdeaBlue>
                                    <p className="text-center mb-0 text-white">Enero 2017</p>
                                </CardIdeaBlue>
                            </ContainerItemIdea>
                        </Col>

                        <Col lg={3} md={6} sm={12} className="position-relative mb-5">
                            <ContainerItemIdea active={tabs2} onClick={() => tabIdea(2)}>
                                <CardIdea>
                                    <p className="text-center mb-0">Se crea el primer prototipo</p>
                                </CardIdea>
                                <CardIdeaBlue>
                                    <p className="text-center mb-0 text-white">Octubre 2017</p>
                                </CardIdeaBlue>
                            </ContainerItemIdea>
                        </Col>

                        <Col lg={3} md={6} sm={12} className="position-relative mb-5">
                            <ContainerItemIdea active={tabs3} onClick={() => tabIdea(3)}>
                                <CardIdea>
                                    <p className="text-center mb-0">Llegan los primeros inversionistas</p>
                                </CardIdea>
                                <CardIdeaBlue>
                                    <p className="text-center mb-0 text-white">Febrero 2018</p>
                                </CardIdeaBlue>
                            </ContainerItemIdea>
                        </Col>
                    </Row>
                </ContainerGenetaTabs>
            </section>
        </Layout>
    )
}

export default AboutUs
